import { UpsertPriceComponent, upsertPriceImports } from '../upsert-price.component';
import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { inOutAnimation } from '../../../../animations';
import { Observable } from 'rxjs';
import { Price } from '../../../../models/price/price';
import { PricingListComponent } from '../pricing-list/pricing-list/pricing-list.component';
import { UpsertBlockTariffComponent } from '../pricing-list/upsert-block-tariff/upsert-block-tariff.component';

@Component({
  selector: 'psc-edit-price',
  standalone: true,
  imports: upsertPriceImports,
  templateUrl: '../upsert-price.component.html',
  animations: [
    inOutAnimation({}),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditPriceComponent extends UpsertPriceComponent implements OnInit {
  @ViewChild('pricingListComponent') pricingListComponent: PricingListComponent;
  @ViewChild('blockTariffComponent') blockTariffComponent: UpsertBlockTariffComponent;

  selectedPrice: Price;

  priceListElement(index: number) {
    return this.pricingList.at(index) as FormGroup;
  }

  timeSlots(index: number): FormArray {
    return this.priceListElement(index)?.controls['timeSlots'] as FormArray;
  }
  get backRoute(): string {
    return '../..';
  }

  override ngOnInit() {
    super.ngOnInit();
    const id = this.route.snapshot.paramMap.get('id')!;
    this.loaderService.showLoader();
    this.priceService.getPrice(id).subscribe(
      {
        next: (price) => {
          this.selectedPrice = price;
          this.updateForm();
          this.loaderService.hideLoader();
        },
        error: () => {
          this.router.navigate(['/404']);
        },
      },
    );
  }

  protected saveToApi(): Observable<Price> {
    const price = JSON.parse(JSON.stringify(this.formGroup.value));

    this.parseFormValueProperly(price);
    return this.priceService.updatePrice(price);
  }


  private updateForm() {
    this.formGroup.patchValue(this.selectedPrice);
    this.blockTariff = this.selectedPrice.blockList?.length > 0;
    this.changeDetectorRef.detectChanges();

    if (this.blockTariff) {
      this.blockTariffComponent.blockList.clear();
      if (this.selectedPrice.blockList[0].priceDistribution_L) {
        this.formGroup.controls['twoTariff'].setValue(true);
      }
      for (let i = 0; i < this.selectedPrice.blockList.length; i++) {
        const block = this.selectedPrice.blockList[i];
        this.blockTariffComponent.addBlock();
        this.blockTariffComponent.blockListElement(i).patchValue(block);
      }
    }

    if (this.selectedPrice.pricingList) {
      const component = this.blockTariff ? this.blockTariffComponent : this.pricingListComponent;

      this.pricingList.clear();
      for (let i = 0; i < this.selectedPrice.pricingList.length; i++) {
        const pricing = this.selectedPrice.pricingList[i];
        component.addPricing();
        const pricingFormGroup = this.pricingList.at(i) as FormGroup;

        pricingFormGroup.controls['dateFrom'].patchValue(this.parseMonthAndDay(pricing.dateFrom));
        pricingFormGroup.controls['dateTo'].patchValue(this.parseMonthAndDay(pricing.dateTo));

        this.timeSlots(i).clear();
        for (let j = 0; j < pricing.timeSlots.length; j++) {
          const timeslot = pricing.timeSlots[j];
          component.addTimeSlot(i);
          this.timeSlots(i).at(j).patchValue(timeslot);
        }
      }
    }
    this.formGroup.updateValueAndValidity();
    this.changeDetectorRef.detectChanges();
  }

  parseMonthAndDay(dateString: string): { month: string, date: string } | null {
    const parts = dateString.match(/--(\d{2})-(\d{2})/);

    if (parts && parts.length === 3) {
      const [, month, day] = parts;
      return { month, date: day };
    } else {
      return null; // Return null if the input string doesn't match the expected format
    }
  }
}
